import {
  PROFILES_PATH,
  updateCurrentProfileAction
} from '@gymaholic/packages'
import { createLogger } from 'logger-js'
import loadReduxAction from 'modules/redux/actions/load'
import getValueReduxUtil from 'modules/redux/utils/get-value'
import {
  TRAINING_USERS_ACTION,
  TRAINING_USERS_ENDPOINT
} from 'modules/training/modules/training-users/constants'
import getEndpointTrainingUtil from 'modules/training/utils/get-endpoint'

const logger = createLogger({
  label: 'loadProfilesUserActions'
})

export default function loadProfilesUserActions ({ options } = {}) {
  return async (dispatch) => {
    try {
      const res = await dispatch(
        loadReduxAction({
          type: TRAINING_USERS_ACTION.LOAD_PROFILES,
          payload: {
            endpoint: getEndpointTrainingUtil(TRAINING_USERS_ENDPOINT.GET_PROFILES),
            domainListPath: PROFILES_PATH.ALL
          },
          options
        })
      )

      const profileId = getValueReduxUtil(res, 'data.profiles.0.id')
      dispatch(
        updateCurrentProfileAction({ data: { id: profileId } })
      )
    } catch (error) {
      logger.error('loading recommended profiles failed ', error)
    }
  }
}
